import { useService } from 'react-reservice';

import { exportService } from './service';

export const useExport = () => {
  return useService(exportService, (state) => state);
};

export { exportService };
